import React from 'react';
import { Badge, BadgeType } from '../../badge';
import * as S from './statement-ui.styles';

export const StatementPrimaryText = S.PrimaryText;
export const StatementSecondaryText = S.SecondaryText;
export const StatementMutedText = S.MutedText;
export const StatementAmount = S.AmountText;
export const StatementDxList = S.DxList;
export const StatementTypeWithIcon = S.TypeWithIcon;

export const StatementCodeBadge: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <Badge type={BadgeType.BLUE_LIGHT} size="small">
        {children}
    </Badge>
);

export const StatementDxBadge: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <Badge type={BadgeType.PURPLE} size="small">
        {children}
    </Badge>
);

export const StatementStatusBadge: React.FC<{ children: React.ReactNode; tone?: 'default' | 'warning' | 'danger' }> = ({
    children,
    tone = 'default',
}) => {
    const type =
        tone === 'danger' ? BadgeType.RED : tone === 'warning' ? BadgeType.ORANGE : BadgeType.BLUE_LIGHT;
    return (
        <Badge type={type} size="small">
            {children}
        </Badge>
    );
};
